$(document)
  .on('click', '.popup-switch', () => {
    $('.popup-layer').fadeToggle(100);
  })
  .on('click', '.close', () => {
    $('.popup-layer').fadeToggle(100);
  });
// .on('click', '.browser-name-item', (e) => {
//   $(e.target).toggleClass('active');
//   $('.browser-name-list').children('.browser-name-item').not($(e.target)).removeClass('active');
// });
$('.browser-name-item').click((e) => {
  // $(e.target).addClass('active');
  const item = $(e.target).parent();
  item.addClass('active');
  item.siblings('.browser-name-item').removeClass('active');
  $('.browser-content .cont-img-item').eq(item.index()).addClass('cont-img-show');
  $('.browser-content .cont-img-item').eq(item.index()).siblings('.cont-img-item').removeClass('cont-img-show');
});
